import React from 'react';
import { 
  Button,
  Card,
  Container,
  Row,
  Col
} from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram
  // faFacebook,
  // faLinkedinIn
 } from '@fortawesome/free-brands-svg-icons';

// core components
// import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import HeaderHomePage from "./Header/HeaderHomePage";
import WebInquiryForm from "../../Forms/WebInquiry"
import './HomePage.css';

const HomePage = () => {

  return (
    <>
    <HeaderHomePage />
    <div className="main">
    <div className="section text-center">
      <Container>
        <Row className="feature-section-description-row">
          <Col className="ml-auto mr-auto" md="8">
            <h2 className="title text-center">What can you find on the website?</h2>
            <h5 className="description">
              On the website you can introduce with Lana Hill`s education and job histories.<br/>
              You can find information about the permit certificates.<br/>
              There are a lot samples of work on the Portfolio page for your review.
            </h5>
            <br />
            <Button
              className="btn-round"
              color="info"
              onClick={(e) => {
                e.preventDefault();
                window.location.href='/about';
              }}
            >
              DETAILS
            </Button>
          </Col>
        </Row>
        <br />
        <br />
        <Row>
          <Col md="4">
            <div className="info">
              <div className="icon icon-info">
                {/* <FontAwesomeIcon icon={faCalendarAlt} className="nc-icon nc-album-2 svg-inline--fa-features" /> */}
                <img
                    className="service-icon"
                    alt="Hair Cutting"
                    src={require("../../../static/images/icons/scissor-and-comb.svg")}
                  />
              </div>
              <div className="description">
                <h4 className="info-title">Hair Cutting</h4>
                <p className="description">
                  I will make sure you receive the best care for your personal needs,
                  whether you`re coming in for just a simple trim or a large-scale change of your style.
                </p>
              </div>
            </div>
          </Col>
          <Col md="4">
            <div className="info">
              <div className="icon icon-info">
                {/* <FontAwesomeIcon icon={faClock} className="nc-icon nc-album-2 svg-inline--fa-features" /> */}
                <img
                    className="service-icon"
                    alt="Hair Cutting"
                    src={require("../../../static/images/icons/female-hairs.svg")}
                  />
              </div>
              <div className="description">
                <h4 className="info-title">Updo</h4>
                <p className="description">
                  Let me create an amazing look for your wedding, prom night, bachelorette party, special event, and more.
                </p>
              </div>
            </div>
          </Col>
          <Col md="4">
            <div className="info">
              <div className="icon icon-info">
                {/* <FontAwesomeIcon icon={faHeadset} className="nc-icon nc-album-2 svg-inline--fa-features" /> */}
                <img
                    className="service-icon"
                    alt="Hair Cutting"
                    src={require("../../../static/images/icons/chromatic.svg")}
                  />
              </div>
              <div className="description">
                <h4 className="info-title">Coloring</h4>
                <p>
                  Color correcting, full head bleach out, glaze, highlights, partial highlight,
                  single color full head, single color root touch-up and more.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    <div className="section section-gray text-center">
      <Container>
        <h2 className="section-title">Hair Stylist</h2>
        <Row>
          <Col md="4">
          </Col>
          <Col md="4">
            <Card className="card-profile card-plain">
              <div className="card-avatar border-white">
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <img
                    className="stylist-image"
                    alt="..."
                    src={require("../../../assets/img/faces/lana-avatar.jpeg")}
                  />
                </a>
              </div>
              <Card.Body>
                <a href="#pablo" className="stylist-profile-link" onClick={e => e.preventDefault()}>
                  <div className="author">
                    <Card.Title tag="h4">Lana Hill</Card.Title>
                    <h6 className="card-category">Consmetologist</h6>
                  </div>
                </a>
                <p className="card-description text-center">
                  I strive to help the clients to find their individual style,
                  which will get them to feel them-self confidence and comfortable.
                  I'm aimed on long-term collaboration with the clients.
                </p>
              </Card.Body>
              <Card.Footer className="text-center">
                <Button
                  className="btn-just-icon btn-neutral"
                  color="link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://instagram.com/lanahillstyle', '_blank');
                  }}
                >
                  <FontAwesomeIcon icon={faInstagram} className="svg-inline--fa-our-stylists" />
                </Button>
                {/*<Button*/}
                {/*  className="btn-just-icon btn-neutral ml-1"*/}
                {/*  color="link"*/}
                {/*  onClick={(e) => {*/}
                {/*    e.preventDefault();*/}
                {/*    window.open('https://facebook.com/lanahillstyle','_blank');*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <FontAwesomeIcon icon={faFacebook} className="svg-inline--fa-our-stylists" />*/}
                {/*</Button>*/}
                {/*<Button*/}
                {/*  className="btn-just-icon btn-neutral ml-1"*/}
                {/*  color="link"*/}
                {/*  onClick={(e) => {*/}
                {/*    e.preventDefault();*/}
                {/*    window.open('https://linkedin.com/lanahillstyle','_blank');*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <FontAwesomeIcon icon={faLinkedinIn} className="svg-inline--fa-our-stylists" />*/}
                {/*</Button>*/}
              </Card.Footer>
            </Card>
          </Col>
          <Col md="4">
          </Col>
        </Row>
      </Container>
    </div>
    <WebInquiryForm />
  </div>
  </>
);
};

export default HomePage;